module.exports = __webpack_public_path__ + "img/feature_yh_bg.bbfcf85d.png";